import type { SxStyle } from '@aibees/shared/theme';

const BLUE_OVERLAY =
  'linear-gradient(164.369deg, rgba(24, 81, 239, 0) 8.7756%, rgba(24, 81, 239, 0.08) 86.387%), linear-gradient(90deg, rgb(255,255,255) 0%, rgb(255,255,255) 100%)';

const PAPER_OVERLAY =
  'linear-gradient(172.676deg, rgba(24, 81, 239, 0) 15.387%, rgba(24, 81, 239, 0.08) 100.49%), linear-gradient(90deg, rgb(255,255,255) 0%, rgb(255,255,255) 100%)';

const PAPER_SHADOW = '0px 24px 48px -12px rgba(10, 13, 18, 0.18)';

export const root: SxStyle = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 0.4fr) minmax(0, 1fr)',
  gap: 1.5,
  width: '100%',
  border: '1px solid',
  borderColor: 'grey.200',
  borderRadius: 1,
  p: 1.5,
  background: BLUE_OVERLAY,
};

const paperBase: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid',
  borderColor: 'rgba(0,0,0,0.08)',
  borderRadius: 0.5,
  p: 1.5,
  boxShadow: PAPER_SHADOW,
  background: PAPER_OVERLAY,
};

export const leftColumn: SxStyle = {
  ...paperBase,
  alignItems: 'center',
  gap: 3,
};

export const rightColumn: SxStyle = {
  ...paperBase,
  gap: 3,
};

export const headSection: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: 1,
  width: '100%',
};

export const videoWrapper: SxStyle = {
  position: 'relative',
  width: '100%',
  flex: 1,
  minHeight: 360,
  borderRadius: 1,
  overflow: 'hidden',
  bgcolor: 'common.black',
};

export const videoContent: SxStyle = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 1.5,
  py: 3,
  px: 2,
  background: 'linear-gradient(180deg, rgba(29,41,57,0) 31.3%, #1d2939 100%)',
};

export const videoTextWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0.5,
  textAlign: 'center',
};

export const creditsContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

export const estimateHeader: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
};

export const categoriesGrid: SxStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: 1,
};

export const categoryCard: SxStyle = {
  bgcolor: 'common.white',
  borderRadius: 0.5,
  p: 1.5,
  display: 'flex',
  flexDirection: 'column',
};

export const categoryHeader: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  pt: 0.5,
  pb: 1.5,
  px: 0.5,
};

export const categoryIconBox: SxStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: 'primary.50',
  borderRadius: 0.5,
  p: 0.25,
};

export const categoryDivider: SxStyle = {
  height: '1px',
  bgcolor: 'grey.300',
  width: '100%',
};

export const rowsWrap: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  pt: 1,
  gap: 0.5,
};

export const creditRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.25,
  px: 0.5,
  borderRadius: 0.5,
  minHeight: 24,
};

export const creditRowLeft: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  flex: 1,
  minWidth: 0,
};

export const creditPill: SxStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0.25,
  bgcolor: 'primary.50',
  borderRadius: 0.5,
  height: 24,
  width: 60,
  p: 0.5,
  flexShrink: 0,
};
